<template>
  <v-container grid-list-lg fluid>
    <div class="headline">Admin Tools</div>
    <!-- <v-btn color="success" @click="migration">migration</v-btn> -->
    <v-row>
      <v-col cols="12">
        <v-card outlined>
          <v-card-text>
            <v-list subheader>
              <v-subheader>User</v-subheader>
              <v-list-item v-if="checkRightStatus(97)" @click="$router.push('/user/create')">
                <v-list-item-avatar tile>
                  <v-img src="@/assets/AdminTools/man.png"></v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>New User</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider inset></v-divider>
              <v-list-item @click="$router.push('/user/list')">
                <v-list-item-avatar tile>
                  <v-img src="@/assets/AdminTools/client.png"></v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>Existing User</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <!-- <v-subheader>Product</v-subheader>
              <v-list-item @click="setOpenRestockSerial(true)">
                <v-list-item-avatar tile>
                  <v-img src="@/assets/AdminTools/packing.png"></v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>Restock Product</v-list-item-title>
                </v-list-item-content>
              </v-list-item> -->

              <!-- <v-subheader>Invoice</v-subheader>
              <v-list-item @click="$router.push('/invoice/adjustCost')">
                <v-list-item-avatar tile>
                  <v-img src="@/assets/AdminTools/budget.png"></v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>Adjust Cost Price</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-subheader>Product</v-subheader>
              <ProductMerge />
               -->
              <v-subheader>Business</v-subheader>
              <!-- <v-list-item @click="$router.push('/inventory/count')">
                <v-list-item-avatar tile>
                  <v-img src="@/assets/AdminTools/inventoryCount.png"></v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>Inventory Check</v-list-item-title>
                </v-list-item-content>
              </v-list-item> -->
              <v-divider inset></v-divider>
              <v-list-item @click="$router.push('/setting')">
                <v-list-item-avatar tile>
                  <v-img src="@/assets/AdminTools/gear.png"></v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>Setting</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-subheader>Payment Service</v-subheader>
              <v-list-item v-if="checkRightStatus(90)" @click="$router.push('/merchant')">
                <v-list-item-avatar tile>
                  <v-img src="@/assets/AdminTools/credit-card.png"></v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>Merchant List</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider inset></v-divider>
              <v-list-item v-if="checkRightStatus(86)" @click="$router.push('/donationCategory')">
                <v-list-item-avatar tile>
                  <v-img src="@/assets/AdminTools/credit-card.png"></v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>Donation Category</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-subheader>Product</v-subheader>
              <v-divider inset></v-divider>
              <v-list-item v-if="checkRightStatus(94)" @click="$router.push('/product/list')">
                <v-list-item-avatar tile>
                  <v-img src="@/assets/Report/business-and-finance.png"></v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>Product List</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-subheader>Counter</v-subheader>
              <v-divider inset></v-divider>
              <v-list-item @click="$router.push('/counter')">
                <v-list-item-avatar tile>
                  <v-img src="@/assets/AdminTools/budget.png"></v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>Counter List</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import invoiceService from '@/modules/Invoice/service.js'
// import ProductMerge from '@/modules/Product/components/Merge.vue'

import { mapActions, mapGetters } from "vuex";
export default {
  // components: {
  //   ProductMerge,
  // },
  computed: {
    ...mapGetters("global", ["checkRightStatus"]),
  },
  methods: {
    ...mapActions("layout", ["setOpenRestockSerial"]),
    async migration() {
      const { value: password } = await this.$swal.fire({
        title: "Enter your password",
        input: "password",
        inputLabel: "Password",
        inputPlaceholder: "Enter your password",
        inputAttributes: {
          maxlength: 10,
          autocapitalize: "off",
          autocorrect: "off",
        },
      });

      if (password === 'pak2312141') {
        this.$swal.fire(`Migration Start`);
        let mig = await invoiceService.migration({
          BusinessId: 1, 
          UserId: 1,
        })

        console.log('migration', mig)

      }
    },
  },
};
</script>

<style scoped></style>
